import { render, staticRenderFns } from "./ts-score-rate.vue?vue&type=template&id=44a35adc&scoped=true"
import script from "./ts-score-rate.vue?vue&type=script&lang=js"
export * from "./ts-score-rate.vue?vue&type=script&lang=js"
import style0 from "./ts-score-rate.vue?vue&type=style&index=0&id=44a35adc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a35adc",
  null
  
)

export default component.exports